
import { Component, Vue } from 'vue-property-decorator';
import MyCompanyAppusersIndex from '@/pages/mycompany/appusers/Index.vue';
import OsAppUsersByCampaignOverview from '@/components/shared/appusers/OsAppUsersByCampaignOverview.vue';
import userModule from '@/store/UserModule';
import OsAppusersOverview from '@/components/shared/appusers/OsAppusersOverview.vue';
@Component({
  components: {
    OsAppusersOverview,
    OsAppUsersByCampaignOverview,
    MyCompanyAppusersIndex
  }
})
export default class CampaignAppUsersIndex extends Vue {
  customerId!: string;
  campaignId!: string;

  async created() {
    this.customerId = userModule.state.customer!.id;
    this.campaignId = this.$route.params.campaignid;
  }
}
